import "../../styles/reset.css";
import "./Header.css";
import React from "react";
import Search from "../search/Search";
import logo_csc from "../../assets/svg/logo_csc.svg"
import burger from "../../assets/svg/burger.svg"


class Header extends React.Component {
    render() {
        return (
            <header className="app-header">
                <a className="logo" href="/">
                    <img className="logo__csc" src={logo_csc}/>
                    <h1 className="logo__notes">Notes</h1>
                </a>
                <div className="header-controls">
                    <Search/>
                    <button className="icon-button" type="button">
                        <img src={burger}/>
                    </button>
                </div>
            </header>
        );
    }

}

export default Header;
